import Feature from 'ol/Feature';
import { Icon, Style, Fill, Stroke, Text, Circle } from 'ol/style';
import { DistributionColor } from '../modules/domain/enums/distribution-color';
import Constants from '../modules/shared/constants';

export class StyleUtils {
    public static getProgressStyle(feature: Feature): Style[] {
        const progress: number = feature.get('progress');
        const transparency: string = feature.get('transparency');
        const strokeTransparency: number = feature.get('strokeTransparency');
        const isNDS: boolean = feature.get('isNDS');
        let style: Style = null;
        if (progress === 0 || progress === undefined || progress === null) {
            if (isNDS) {
                style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.Black, transparency, strokeTransparency);
            } else {
                style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.Red, transparency, strokeTransparency);
            }
        } else if (progress >= 10 && progress < 80) {
            style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.Orange, transparency, strokeTransparency);
        } else if (progress >= 80 && progress < 95) {
            style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.Yellow, transparency, strokeTransparency);
        } else if (progress >= 95 && progress < 100) {
            style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.Green, transparency, strokeTransparency);
        } else {
            style = StyleUtils.getStyleByColorAndTransparencies(DistributionColor.DarkGreen, transparency, strokeTransparency);
        }
        return [style];
    }

    public static getEventStyle(feature: Feature): Style[] {
        const type: number = feature.get('type');
        switch (type) {
            case 0:
                return StyleUtils.getIconStyle('../../assets/icons/startreg.svg');
            case 1:
                return StyleUtils.getIconStyle('../../assets/icons/pausereg.svg');
            case 2:
                return StyleUtils.getIconStyle('../../assets/icons/startfence.svg');
            case 3:
                return StyleUtils.getIconStyle('../../assets/icons/endfence.svg');
            case 4:
                const colorWkt: string = feature.get('color');
                return [StyleUtils.getStyleByColorAndTransparencies(colorWkt, '0.2', 0.2)];
            case 5:
                let count: number = feature.get('number');
                let scale: number = count < 1000 ? 1 : 0.8;
                const colorPoint: string = feature.get('color');
                return StyleUtils.getTrackingPointStyle(count.toString(), scale, colorPoint);
            default:
                return StyleUtils.getIconStyle('../../assets/icons/dot.svg');
        }
    }

    public static getStyleByColorAndTransparencies(color: string, transparencyFill: string, transparencyStroke: number): Style {
        return new Style({
            fill: new Fill({
                color: color.replace('(', 'a(').replace(')', ',' + transparencyFill + ')')
            }),
            stroke: new Stroke({
                color: color.replace('(', 'a(').replace(')', ',' + transparencyStroke + ')'),
                width: 10
            })
        });
    }

    public static getIconStyle(iconPath: string): Style[] {
        return [
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: Constants.IconColors.TrackingText.replace('(', 'a(').replace(')', ',' + 1 + ')'),
                    }),
                    radius: 20,
                    scale: 1
                })
            }),
            new Style({
                image: new Icon({
                    scale: 0.05,
                    src: iconPath
                })
            })
        ];
    }
    public static getTrackingPointStyle(label: string, scale: number, color: string): Style[] {
        return [
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: color,
                    }),
                    radius: 15,
                    scale: 1,
                    stroke: new Stroke({
                        color: Constants.IconColors.TrackingText,
                        width: 2
                    })
                })
            }),
            new Style({
                text: new Text({
                    text: label,
                    offsetY: 0,
                    scale: scale,
                    fill: new Fill({
                        color: Constants.IconColors.TrackingText,
                    })
                })
            })
        ];
    }
    public static getAddressStyle(feature: Feature): Style[] {
        const weight: number = feature.get('weight');
        const visible: boolean = feature.get('visible');
        const color: string = feature.get('addressColor');
        const style: Style = new Style({
            image: new Circle({
                fill: new Fill({
                    color: color.replace('(', 'a(').replace(')', ',' + 1 + ')'),
                }),
                radius: 5,
                scale: visible ? StyleUtils.getAddressScale(weight) : 0
            })
        });
        return style;
    }

    public static getAddressScale(weight: number): number {
        if (weight === 1)
            return 0.8;
        if (weight > 1 && weight <= 10)
            return 1;
        if (weight > 10 && weight <= 20)
            return 1.5;
        if (weight > 20 && weight <= 50)
            return 2;
        if (weight > 50)
            return 3;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/style-utils.ts